import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracaoConsultaPrestadoresServicosEmpresasTerceirizadas: ['administracao'],
    setTipoContratoConsultaPrestadoresServicosEmpresasTerceirizadas: ['tipoContrato'],
    setExercicioContratoConsultaPrestadoresServicosEmpresasTerceirizadas: ['exercicioContrato'],
    setNumeroContratoConsultaPrestadoresServicosEmpresasTerceirizadas: ['numeroContrato'],
    setObjetoContratoConsultaPrestadoresServicosEmpresasTerceirizadas: ['objetoContrato'],
    setNomeContratadoContratoConsultaPrestadoresServicosEmpresasTerceirizadas: ['nomeContratadoContrato'],
    setTipoCompraConsultaPrestadoresServicosEmpresasTerceirizadas: ['tipoCompra'],
    setDataValidadeInicialConsultaPrestadoresServicosEmpresasTerceirizadas: ['dataValidadeInicial'],
    setDataValidadeFinalConsultaPrestadoresServicosEmpresasTerceirizadas: ['dataValidadeFinal'],
    limpaFiltroConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    receberFiltroConsultaPrestadoresServicosEmpresasTerceirizadas: ['filtroRecebido'],
    setStatusConsultaPrestadoresServicosEmpresasTerceirizadas: ['status'],
})

const INITIAL_STATE = {
    administracao: [],
    tipoContrato: [],
    exercicioContrato: '',
    numeroContrato: '',
    objetoContrato: '',
    nomeContratadoContrato: '',
    tipoCompra: '',
    dataValidadeInicial: '',
    dataValidadeFinal: '',
    status: { label: 'Ativo', value: 'A' },
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setTipoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, tipoContrato: action.tipoContrato }
}

const setExercicioContrato = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioContrato: action.exercicioContrato }
}

const setNumeroContrato = (state = INITIAL_STATE, action) => {
    return { ...state, numeroContrato: action.numeroContrato }
}

const setObjetoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, objetoContrato: action.objetoContrato }
}

const setNomeContratadoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, nomeContratadoContrato: action.nomeContratadoContrato }
}

const setTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: action.tipoCompra }
}

const setDataValidadeInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataValidadeInicial: action.dataValidadeInicial }
}

const setDataValidadeFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataValidadeFinal: action.dataValidadeFinal }
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setAdministracao,
    [Types.SET_TIPO_CONTRATO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setTipoContrato,
    [Types.SET_EXERCICIO_CONTRATO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setExercicioContrato,
    [Types.SET_NUMERO_CONTRATO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setNumeroContrato,
    [Types.SET_OBJETO_CONTRATO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setObjetoContrato,
    [Types.SET_NOME_CONTRATADO_CONTRATO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setNomeContratadoContrato,
    [Types.SET_TIPO_COMPRA_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setTipoCompra,
    [Types.SET_DATA_VALIDADE_INICIAL_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setDataValidadeInicial,
    [Types.SET_DATA_VALIDADE_FINAL_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setDataValidadeFinal,
    [Types.LIMPA_FILTRO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setStatus,
})
